import { useEffect } from 'react';
import type { TRef } from './useIsVisible';
import { useIsVisible } from './useIsVisible';

export function IsVisible({
  children,
  onChange,
  options,
}: {
  children: React.ReactNode | ((arg: { isVisible: boolean; ref: React.RefObject<TRef> }) => React.ReactNode);
  onChange?: (isVisible: boolean) => void;
  options?: IntersectionObserverInit;
}) {
  const { ref, isVisible } = useIsVisible(options);

  useEffect(() => {
    onChange?.(isVisible);
  }, [onChange, isVisible]);

  if (typeof children === 'function') {
    return <>{children({ isVisible, ref })}</>;
  } else {
    return <div ref={ref}>{children}</div>;
  }
}
